document.addEventListener('product:added', function(event) {
  // This event can be called from Add to Cart, Quick Add to Cart, and the Wiser Add to Cart.
  var variant = event.detail.variant; // Get the variant that was added
  var quantity = event.detail.quantity; // Get the quantity that was added

  if (variant === undefined) {
    return false; // this indicates that the event came from Wiser
    // We should probably fix this some time!
  }

  if (variant.image === undefined && variant.featured_image !== null) { // this catches the case where the normal add is used instead of quick add
    variant.image = variant.featured_image.src;
  }

  if (variant.image === undefined) {
    variant.image = $('.Product__Gallery img')[0]['src'];
  }

  if (variant.image != undefined && !variant.image.includes("https:")) {
    variant.image = "https:"+variant.image;
  }

  var _learnq = window._learnq || [];
  _learnq.push(["track", "Added to Cart", {
    AddedItemPrice: variant.price / 100,
    AddedItemProductID: variant.id,
    AddedItemProductName: variant.name,
    AddedItemUrl: location.href,
    AddedItemImageUrl: variant.image,
    AddedItemQuantity: quantity,
    AddedItemSKU: variant.sku
  }]);
});

document.addEventListener('product:quickadded', function(event) {
  gtag("event", "Quick Added Product");
});
